import React from 'react';

import { TTab, Tab } from './Tab';

export type TProps = {
  items: TTab[];
  onClick: (tabId: string) => void;
};

export const Tabs = React.memo(({ items, onClick }: TProps) => {
  const list = items.map(item => ({
    ...item,
    onClick: () => !item.active && onClick(item.id),
  }));

  if (list.length <= 1) return null;

  return (
    <div className="vitrine-template__tabs">
      {list.map(item => (
        <Tab key={item.key} data={item} onClick={item.onClick} />
      ))}
    </div>
  );
});
